import httpClient from "./httpClient";
import { AxiosRequestConfig } from "axios";
import DomainHandler from "@/whitelabel/domainHandler";

type DataDefault = Record<string, unknown>;

export const get = <TResponse = any>(api: string, config?: AxiosRequestConfig) => {
  return httpClient.get<TResponse>(`${DomainHandler.resolveApiDomain()}/${api}`, config);
};

export const post = <TResponse = any, TData = DataDefault>(api: string, data?: TData, config?: AxiosRequestConfig) => {
  return httpClient.post<TResponse>(`${DomainHandler.resolveApiDomain()}/${api}`, data, config);
};

export const put = <TResponse = any, TData = DataDefault>(api: string, data?: TData, config?: AxiosRequestConfig) => {
  return httpClient.put<TResponse>(`${DomainHandler.resolveApiDomain()}/${api}`, data, config);
};

export const patch = <TResponse = any, TData = DataDefault>(api: string, data?: TData, config?: AxiosRequestConfig) => {
  return httpClient.patch<TResponse>(`${DomainHandler.resolveApiDomain()}/${api}`, data, config);
};

export const Delete = <TResponse = any>(api: string, config?: AxiosRequestConfig) => {
  return httpClient.delete<TResponse>(`${DomainHandler.resolveApiDomain()}/${api}`, config);
};
